import _ from "lodash";
import React, { useState, useEffect, useMemo } from "react";
import classes from "./CriteriaRating.scss";
import classNames from "classnames";
import { onEnterOrSpaceKeyDown } from "Utils";
import { useDSContext } from "@toddle-edu/ds-web";

const CriteriaRating = ({
  isEvaluation,
  options,
  value,
  onCriteriaClick,
  isViewMode,
  containerStyle,
  shouldUpdateOnValueChnage,
  customSelectedStyle,
  timeOut = 1000,
  customViewModeClass,
  customRatingElementClass,
  customSelectedRatingElement,
  shouldStopPropagation = false,
  selectedCriteriaRef = {},
  showEmptyValueInSelection,
  isSelectedClickDisabled,
  testId,
  isAISelectedCriteria,
}) => {
  const [selectedCriteria, setSelectedCriteria] = useState(value);
  const [selectionTimerId, setSelectionTimerId] = useState(null);
  const { dsVersion } = useDSContext();
  const isDSV2 = dsVersion === "2.0";

  const doesSelectedValueExists = useMemo(() => {
    return !_.isNil(value) && _.size(value) > 0;
  }, [value]);

  useEffect(() => {
    if (shouldUpdateOnValueChnage) {
      setSelectedCriteria(value);
    }
  }, [value, shouldUpdateOnValueChnage]);
  return (
    <div
      className={classNames(classes.ratingElementsContainer, {
        [classes.ratingElementsContainerV2]: isDSV2,
      })}
      style={containerStyle}
    >
      {_.map(options, (option, index) => {
        const isSelected =
          !selectedCriteria && showEmptyValueInSelection && option.label == "-"
            ? true
            : option.id === selectedCriteria;

        const ratingElementClass = classNames(
          { [customViewModeClass]: !_.isEmpty(customViewModeClass) },
          { [classes.ratingElement]: !isDSV2 },
          { [classes.ratingElementV2]: isDSV2 },
          { "text-body-s": isDSV2 },
          { [classes.ratingElementDisabled]: isViewMode },
          { [classes.ratingElementDisabledV2]: isViewMode && isDSV2 },
          { [classes.ratingElementInteractable]: isEvaluation },
          { [classes.selectedRatingElement]: isSelected },
          { [classes.selectedRatingElementV2]: isSelected && isDSV2 },
          {
            [customSelectedRatingElement]:
              isSelected && !_.isEmpty(customSelectedRatingElement),
          },
          { [customRatingElementClass]: !_.isEmpty(customRatingElementClass) }
        );

        const onClickEvaluation = e => {
          if (isEvaluation && !isViewMode) {
            if (shouldStopPropagation) {
              e.stopPropagation();
            }
            const updatedCriteria =
              option.id === selectedCriteria ? "" : option.id;

            if (!isAISelectedCriteria) {
              setSelectedCriteria(updatedCriteria);
            }

            // clear action of pervious interaction
            clearTimeout(selectionTimerId);
            setSelectionTimerId(
              setTimeout(() => {
                // after new interactions if no criteria is selected, and if previously a critria was selected
                // then we need to delete that criteria rating
                if (!updatedCriteria && value) {
                  onCriteriaClick(value);
                } else if (updatedCriteria) {
                  // create a new criteria rating with the updated value
                  onCriteriaClick(option.id);
                }
              }, timeOut)
            );
          }
        };

        return (
          <div
            className={ratingElementClass}
            key={option.id}
            style={isSelected ? customSelectedStyle : {}}
            tabIndex={isEvaluation && !isViewMode ? 0 : null}
            onClick={
              isSelected && isSelectedClickDisabled
                ? () => {}
                : onClickEvaluation
            }
            onKeyDown={e => onEnterOrSpaceKeyDown(e, onClickEvaluation)}
            data-test-id={`${testId}-criteriaRating-${option.id}`}
            data-is-selected={isSelected}
            ref={ref => {
              if (
                (doesSelectedValueExists && isSelected) ||
                (!doesSelectedValueExists && index === 0)
              ) {
                selectedCriteriaRef.current = ref;
              }
            }}
          >
            {option.label}
          </div>
        );
      })}
    </div>
  );
};

CriteriaRating.defaultProps = {
  containerStyle: {},
  customSelectedStyle: {},
  isAISelectedCriteria: false,
};

export default CriteriaRating;
